import React, { Component } from 'react'
import { bindActionCreators} from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import _ from 'lodash'
import {Link} from 'react-router-dom'
import {Card, Statistic, List, Label} from 'semantic-ui-react'
import {api} from '../api'

class Dashboard extends Component {
    constructor() {
        super();
        this.state = {
            my: {
                count: 0,
                orders: []
            },
            orders: {
                count: 0,
                orders: []
            },
            receiving: {
                count: 0,
                orders: []
            },
            shipping: {
                count: 0,
                orders: []
            },
            qb: {
                count: 0,
                orders: []
            }
        }
    }

    componentDidMount() {
        const {jwt} = this.props;
        api.dashboard.my(jwt).then(res => {
            this.setState({
                my: res.data.data
            })
        });
        api.dashboard.pendingOrder(jwt).then(res => {
            this.setState({
                orders: res.data.data
            })
        });
        api.dashboard.pendingReceiving(jwt).then(res => {
            this.setState({
                receiving: res.data.data
            })
        });
        api.dashboard.pendingShipping(jwt).then(res => {
            this.setState({
                shipping: res.data.data
            })
        });
        api.dashboard.pendingQb(jwt).then(res => {
            this.setState({
                qb: res.data.data
            })
        });
    }

    getWarehouse = (shipment) => {
        if (!shipment) {
            return "NA";
        }
        const {warehouse_id} = shipment;
        const {warehouses} = this.props;
        const wh = warehouses.filter(w => {
            return parseInt(w.value) === parseInt(warehouse_id);
        });
        if (wh.length > 0) {
            return wh[0].text;
        }
    }

    meHref = (i) => {
        //http://localhost:3000/customer-orders/53/view
        const {id, type} = i;
        const routeType = type.replace(/\s+/g, '-').toLowerCase()+'s';
        return `/${routeType}/${id}/view`;
    }

    shipHref = (i) => {
        const {acct_type, id} = i;
        //http://localhost:3000/shipments/shipping/83/view
        let route = 'shipping';
        if (acct_type === 'Bill') {
            route = 'receiving';
        }
        if (acct_type === 'Credit Memo') {
            route = 'receiving';
        }
        return `/shipments/${route}/${id}/view`
    }
    
    render() {
        const {my,orders,receiving,shipping,qb} = this.state;
        return (
            <div className="row">
                <div className="col-md-12">
                    <Card.Group>
                        <Card>
                            <Card.Content>
                                <Card.Header>
                                    <Statistic>
                                        <Statistic.Value>{my.count}</Statistic.Value>
                                        <Statistic.Label>My Pending Orders</Statistic.Label>
                                    </Statistic>
                                </Card.Header>
                                <Card.Description>
                                    <List divided relaxed>
                                        {my.orders.map(o => {
                                            return <List.Item key={o.id}>
                                                <List.Icon name='list' size='large' verticalAlign='middle' />
                                                <List.Content>
                                                    <List.Header as={Link} to={this.meHref(o)}>
                                                        <Label size="mini" color="grey">
                                                            {o.status}
                                                        </Label>
                                                        &nbsp;&nbsp;
                                                        {o.so}
                                                    </List.Header>
                                                    <List.Description>
                                                        {o.relations ? o.relations.company_name : ""}
                                                    </List.Description>
                                                </List.Content>
                                            </List.Item>
                                        })}
                                    </List>
                                </Card.Description>
                            </Card.Content>
                        </Card>
                        
                        <Card>
                            <Card.Content>
                                <Card.Header>
                                    <Statistic>
                                        <Statistic.Value>{orders.count}</Statistic.Value>
                                        <Statistic.Label>Open or Finalized Orders</Statistic.Label>
                                    </Statistic>
                                </Card.Header>
                                <Card.Description>
                                    <List divided relaxed>
                                        {orders.orders.map(o => {
                                            return <List.Item key={o.id}>
                                                <List.Icon name='list' size='large' verticalAlign='middle' />
                                                <List.Content>
                                                    <List.Header as={Link} to={this.meHref(o)}>
                                                        <Label size="mini" color="yellow">
                                                            {o.status}
                                                        </Label>
                                                        &nbsp;&nbsp;
                                                        {o.so}
                                                    </List.Header>
                                                    <List.Description>
                                                        {o.relations ? o.relations.company_name : ""}
                                                    </List.Description>
                                                </List.Content>
                                            </List.Item>
                                        })}
                                    </List>
                                </Card.Description>
                            </Card.Content>
                        </Card>

                        <Card>
                            <Card.Content>
                                <Card.Header>
                                    <Statistic>
                                        <Statistic.Value>{receiving.count}</Statistic.Value>
                                        <Statistic.Label>To Be Received</Statistic.Label>
                                    </Statistic>
                                </Card.Header>
                                <Card.Description>
                                    <List divided relaxed>
                                        {receiving.orders.map(o => {
                                            return <List.Item key={o.id}>
                                                <List.Icon name='list' size='large' verticalAlign='middle' />
                                                <List.Content>
                                                    <List.Header as={Link} to={this.shipHref(o)}>
                                                        <Label size="mini" color="green">
                                                            {this.getWarehouse(o)}
                                                        </Label>
                                                        &nbsp;&nbsp;
                                                        {o.id}
                                                    </List.Header>
                                                    <List.Description>
                                                        {o.relation_name ? o.relation_name.company_name : ""}
                                                    </List.Description>
                                                </List.Content>
                                            </List.Item>
                                        })}
                                    </List>
                                </Card.Description>
                            </Card.Content>
                        </Card>

                        <Card>
                            <Card.Content>
                                <Card.Header>
                                    <Statistic>
                                        <Statistic.Value>{shipping.count}</Statistic.Value>
                                        <Statistic.Label>To Be Shipped</Statistic.Label>
                                    </Statistic>
                                </Card.Header>
                                <Card.Description>
                                    <List divided relaxed>
                                        {shipping.orders.map(o => {
                                            return <List.Item key={o.id}>
                                                <List.Icon name='list' size='large' verticalAlign='middle' />
                                                <List.Content>
                                                    <List.Header as={Link} to={this.shipHref(o)}>
                                                        <Label size="mini" color="violet">
                                                            {this.getWarehouse(o)}
                                                        </Label>
                                                        &nbsp;&nbsp;
                                                        {o.id}
                                                    </List.Header>
                                                    <List.Description>
                                                        {o.relation_name ? o.relation_name.company_name : ""}
                                                    </List.Description>
                                                </List.Content>
                                            </List.Item>
                                        })}
                                    </List>
                                </Card.Description>
                            </Card.Content>
                        </Card>

                        <Card>
                            <Card.Content>
                                <Card.Header>
                                    <Statistic>
                                        <Statistic.Value>{qb.count}</Statistic.Value>
                                        <Statistic.Label>Unsychronized To QB</Statistic.Label>
                                    </Statistic>
                                </Card.Header>
                                <Card.Description>
                                    <List divided relaxed>
                                        {qb.orders.map(o => {
                                            return <List.Item key={o.id}>
                                                <List.Icon name='list' size='large' verticalAlign='middle' />
                                                <List.Content>
                                                    <List.Header as={Link} to={this.shipHref(o)}>
                                                        <Label size="mini" color="pink">
                                                            {this.getWarehouse(o)}
                                                        </Label>
                                                        &nbsp;&nbsp;
                                                        {o.id}
                                                    </List.Header>
                                                    <List.Description>
                                                        {o.relation_name ? o.relation_name.company_name : ""}
                                                    </List.Description>
                                                </List.Content>
                                            </List.Item>
                                        })}
                                    </List>
                                </Card.Description>
                            </Card.Content>
                        </Card>
                    </Card.Group>
                </div>
            </div>
        )
    }
}

Dashboard.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
     }).isRequired,
    jwt: PropTypes.string.isRequired,
    warehouses: PropTypes.array.isRequired
};

function mapStateToProps(state) {
    return {
        jwt: state.auth.jwt,
        warehouses: state.system.resources.warehouses
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)


// WEBPACK FOOTER //
// ./src/components/Dashboard.js